import { ID } from './id';
import { GroupByMode, SortingMode } from './sorting-mode';
import { TaskPriorityOptions, TaskType } from './task-base';

export enum DocumentOrganizationKeys {
  SortingMode = 'sortingMode',
  GroupByMode = 'groupByMode',
  Filters = 'filters',
  CollapsedSections = 'collapsedSections',
}

export enum FilterOptionKeys {
  LifeArea = 'lifeArea',
  Priority = 'priority',
  Type = 'type',
  Tag = 'tag',
  Duration = 'duration',
  Goal = 'goal',
}

export type FilterDocument = {
  [DocumentOrganizationKeys.SortingMode]?: SortingMode | null;
  [DocumentOrganizationKeys.GroupByMode]?: GroupByMode | null;
  [DocumentOrganizationKeys.CollapsedSections]?: ID[] | null;
  [DocumentOrganizationKeys.Filters]?: {
    [FilterOptionKeys.LifeArea]?: FilterDocumentFilter<ID>;
    [FilterOptionKeys.Priority]?: FilterDocumentFilter<TaskPriorityOptions>;
    [FilterOptionKeys.Type]?: FilterDocumentFilter<TaskType>;
    [FilterOptionKeys.Tag]?: FilterDocumentFilter<ID>;
    [FilterOptionKeys.Goal]?: FilterDocumentFilter<ID>;
    [FilterOptionKeys.Duration]?: {
      more?: { type: 'minutes'; value: number } | null;
      less?: { type: 'minutes'; value: number } | null;
    };
  } | null;
};

export type FilterDocumentFilter<TypeToSave extends string> = {
  include?: TypeToSave[] | null;
};
